import { render, staticRenderFns } from "./investment-type-option.vue?vue&type=template&id=2cebe53a&scoped=true"
import script from "./investment-type-option.vue?vue&type=script&lang=js"
export * from "./investment-type-option.vue?vue&type=script&lang=js"
import style0 from "./investment-type-option.vue?vue&type=style&index=0&id=2cebe53a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cebe53a",
  null
  
)

export default component.exports